import { combineReducers } from 'redux';
import app from './app';
import auth from './auth';

const createRootReducer = history => combineReducers({
    app,
    auth
});

export default createRootReducer;